
import { Vue, Component, Prop } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import Validation from "@/components/Validation.vue";

@Component({
  components: {
    Validation
  }
})
export default class ForgotPasswordForm extends Vue {
  public name: string = "ForgotPasswordForm";

  @Prop({ required: false, default: false })
  public reset!: boolean;

  protected showErrors = true;

  protected email: string = "";

  @Validations()
  validations() {
    let fields = {};
    fields = Object.assign({}, fields, {
      email: { required, email }
    });
    return fields;
  }

  public onSubmit(): void {
    this.$v.$touch();
    this.showErrors = true;
    if (this.$v.$invalid) {
      return;
    }

    this.$emit("onSubmit", {
      email: this.email
    });

    this.showErrors = false;

    if (this.reset) {
      this.email = "";
    }
  }
}
